const collator = new Intl.Collator(undefined, {
    numeric: true,
    sensitivity: "base"
});

const emptyRank = (value: unknown) =>
    value === null || value === undefined || String(value).trim() === "" ? 1 : 0;

export const sortText = (...values: Array<unknown>) => values
    .map(value => value === null || value === undefined ? "" : String(value).trim())
    .filter(Boolean)
    .join(" ");

export const compareNullableText = (left: unknown, right: unknown) => {
    const leftRank = emptyRank(left);
    const rightRank = emptyRank(right);
    if (leftRank !== rightRank) {
        return leftRank - rightRank;
    }

    if (leftRank === 1) {
        return 0;
    }

    return collator.compare(String(left).trim(), String(right).trim());
};

const toNumber = (value: unknown) => {
    if (typeof value === "number") {
        return Number.isFinite(value) ? value : null;
    }

    if (typeof value === "string" && value.trim()) {
        const parsed = Number(value.replace(",", "."));
        return Number.isFinite(parsed) ? parsed : null;
    }

    return null;
};

export const compareNullableNumber = (left: unknown, right: unknown) => {
    const leftNumber = toNumber(left);
    const rightNumber = toNumber(right);
    const leftRank = leftNumber === null ? 1 : 0;
    const rightRank = rightNumber === null ? 1 : 0;
    if (leftRank !== rightRank) {
        return leftRank - rightRank;
    }

    if (leftNumber === null || rightNumber === null) {
        return 0;
    }

    return leftNumber - rightNumber;
};

const toTimestamp = (value: unknown) => {
    if (value instanceof Date) {
        const timestamp = value.getTime();
        return Number.isFinite(timestamp) ? timestamp : null;
    }

    if (typeof value === "string" && value.trim()) {
        const timestamp = Date.parse(value);
        return Number.isFinite(timestamp) ? timestamp : null;
    }

    return null;
};

export const compareNullableDate = (left: unknown, right: unknown) => {
    const leftTimestamp = toTimestamp(left);
    const rightTimestamp = toTimestamp(right);
    const leftRank = leftTimestamp === null ? 1 : 0;
    const rightRank = rightTimestamp === null ? 1 : 0;
    if (leftRank !== rightRank) {
        return leftRank - rightRank;
    }

    if (leftTimestamp === null || rightTimestamp === null) {
        return 0;
    }

    return leftTimestamp - rightTimestamp;
};

export const textSorter = <T>(selector: (item: T) => unknown) =>
    (left: T, right: T) => compareNullableText(selector(left), selector(right));

export const numberSorter = <T>(selector: (item: T) => unknown) =>
    (left: T, right: T) => compareNullableNumber(selector(left), selector(right));

export const dateSorter = <T>(selector: (item: T) => unknown) =>
    (left: T, right: T) => compareNullableDate(selector(left), selector(right));
